module.exports = __webpack_public_path__ + "static/media/moreActive.14b351bc.svg";